{
  "_comment": "norm.necessity records whether a disclosure APPLIES to a company (topic relevance). It does NOT record whether a nil answer must be stated in the report. Worked counter-example: b5p35-has-sensitive-sites (VSME §33) and b11p43-has-issues (§43) both carry 'necessary_if_applicable' and behave OPPOSITELY — §33 says 'the undertaking shall disclose the number and area', so nil is required; §43 says 'In case of convictions and fines', so nil is not owed at all. Before making a renderer assert a negative, read the paragraph itself and record it in sections.json under norm_basis — see docs/plugins/vsme/norm-negative-disclosures.md.",
  "version": "2.2.0",
  "composite_targets": {
    "B2P29": [
      "b2p29-a",
      "b2p29-b",
      "b2p29-d"
    ],
    "B2P29__C2P47": [
      "b2p29-a",
      "b2p29-b",
      "b2p29-d",
      "c2p47",
      "c2p47-b",
      "c2p48"
    ],
    "B8P40": [
      "b8p40-a",
      "b8p40-b",
      "b8p40-c"
    ],
    "B8P40__C5P59": [
      "b8p40-a",
      "b8p40-b",
      "b8p40-c",
      "c5p59__c5p60",
      "c5p60",
      "c5p60-temporary-agency-workers"
    ]
  },
  "step_bindings": [
    {
      "step_id": "B2P29",
      "disclosure_ids": [
        "b2p29-a",
        "b2p29-b",
        "b2p29-d"
      ],
      "form_field_ids": [
        "b2p29_sustainability_table"
      ]
    },
    {
      "step_id": "B2P29__C2P47",
      "disclosure_ids": [
        "b2p29-a",
        "b2p29-b",
        "b2p29-d",
        "c2p47",
        "c2p47-b",
        "c2p48"
      ],
      "form_field_ids": [
        "b2p29__c2p47_sustainability_table"
      ]
    },
    {
      "step_id": "B8P40",
      "disclosure_ids": [
        "b8p40-a",
        "b8p40-b",
        "b8p40-c"
      ],
      "form_field_ids": [
        "b8p40_employee_distribution"
      ]
    },
    {
      "step_id": "B8P40__C5P59",
      "disclosure_ids": [
        "b8p40-a",
        "b8p40-b",
        "b8p40-c",
        "c5p59__c5p60",
        "c5p60",
        "c5p60-temporary-agency-workers"
      ],
      "form_field_ids": [
        "b8p40__c5p59_employee_distribution",
        "c5p59_management_ratio",
        "c5p60_workforce_extras"
      ]
    }
  ],
  "disclosures": [
    {
      "id": "b1p27-a",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "a"
        ],
        "ref": "§24 (a)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-01"
        ],
        "form_fields": [
          "b1p27-a_choice"
        ],
        "schema_steps": [
          "b1p27-a"
        ]
      },
      "display": {
        "title": "Choix du module",
        "description": [
          "Conformément au paragraphe 27 de la norme VS, vous devez indiquer si vous appliquez :",
          "• Module de base : uniquement le module de base, recommandé pour les micro-entreprises et minimum requis pour les autres.",
          "• Module de base et complet : le module de base et le module narratif, en complément si vos partenaires (banques, grandes entreprises) exigent des informations plus détaillées.",
          "Une fois une option choisie, le module concerné doit être appliqué dans son intégralité, sauf si certaines informations sont jugées non pertinentes."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-c",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "c"
        ],
        "ref": "§24 (c)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-03"
        ],
        "form_fields": [
          "b1p27-c_scope"
        ],
        "schema_steps": [
          "b1p27-c"
        ]
      },
      "display": {
        "title": "Périmètre du rapport",
        "description": [
          "Conformément au paragraphe 27, point c) de la norme VS, indiquer si le rapport de durabilité est :",
          "• Individuel : le rapport contient uniquement les données de l'entreprise déclarante.",
          "• Consolidé : le rapport inclut également les données de ses filiales.",
          "Il est recommandé aux entreprises mères d'un groupe de produire un rapport consolidé, auquel cas les filiales n'ont pas à établir leur propre rapport (paragraphe 14-15)."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-d",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "d"
        ],
        "ref": "§24 (d)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B1-04"
        ],
        "form_fields": [
          "b1p27-d_subsidiaries"
        ],
        "schema_steps": [
          "b1p27-d"
        ]
      },
      "display": {
        "title": "Liste des filiales",
        "description": [
          "Lorsque le rapport est établi sur une base consolidée, conformément au paragraphe 27, point d) de la norme VS, la liste des filiales incluses doit être fournie, accompagnée de leur adresse enregistrée.",
          "Cette information permet de définir précisément le périmètre du rapport de durabilité consolidé."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-i",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "i"
        ],
        "ref": "§24 (e i.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-05"
        ],
        "form_fields": [
          "b1p27-e-i_legal_form"
        ],
        "schema_steps": [
          "b1p27-e-i"
        ]
      },
      "display": {
        "title": "Forme juridique de l'entreprise",
        "description": [
          "Conformément au paragraphe 27, point e) i) de la norme VS, il convient d'indiquer la forme juridique de l'entreprise parmi les options suivantes :",
          "• Entreprise privée à responsabilité limitée",
          "• Entreprise individuelle",
          "• Société de personnes",
          "• Coopérative",
          "• Autre (à préciser)",
          "Cette information permet de contextualiser le profil juridique de l'entité déclarante dans le cadre du rapport de durabilité."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-ii",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "ii"
        ],
        "ref": "§24 (e ii.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-06"
        ],
        "form_fields": [
          "b1p27-e-ii_nace"
        ],
        "schema_steps": [
          "b1p27-e-ii"
        ]
      },
      "display": {
        "title": "Code(s) NACE de l'entreprise",
        "description": [
          "Conformément au paragraphe 27, point e) ii) de la norme VS, les entreprises doivent indiquer leur ou leurs codes NACE, qui classifient les activités économiques selon la nomenclature européenne.",
          "Le code peut comporter de 2 à 5 chiffres, selon le niveau de précision. Cette information est essentielle pour situer l'entreprise dans son secteur et permettre la comparabilité entre entités.",
          "La liste des codes NACE est disponible dans le règlement (UE) 2023/137."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-iii",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "iii"
        ],
        "ref": "§24 (e iii.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-07"
        ],
        "form_fields": [
          "b1p27-e-iii_balance_total"
        ],
        "schema_steps": [
          "b1p27-e-iii"
        ]
      },
      "display": {
        "title": "Bilan et chiffre d'affaires",
        "description": [
          "Conformément au paragraphe 27, point e) iii) de la norme VS, la taille du bilan correspond au total de l'actif à la fin de la période de référence.",
          "Cette donnée permet de déterminer la catégorie de l'entreprise (micro, petite ou moyenne) au sens de la directive comptable 2013/34/UE et de vérifier son éligibilité à l'application de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-iv",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "iv"
        ],
        "ref": "§24 (e iv.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-08"
        ],
        "form_fields": [
          "b1p27-e-iv_turnover"
        ],
        "schema_steps": [
          "b1p27-e-iv"
        ]
      },
      "display": {
        "title": "Bilan et chiffre d'affaires",
        "description": [
          "Conformément au paragraphe 27, point e) iv) de la norme VS, le chiffre d'affaires à déclarer correspond au revenu net généré par les ventes de biens ou de services, après déductions des remises, rabais et taxes.",
          "Cette information est utilisée pour classer l'entreprise dans l'une des catégories de taille définies par la directive 2013/34/UE (micro, petite ou moyenne entreprise)."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-v",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "v"
        ],
        "ref": "§24 (e v.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-09"
        ],
        "form_fields": [],
        "schema_steps": [
          "b1p27-e-v"
        ]
      },
      "display": {
        "title": "Nombre d'employés en effectif ou équivalent temps plein",
        "description": [
          "Conformément au paragraphe 27, point e) v) de la norme VS, indiquer le nombre moyen de salariés employés au cours de l'exercice, soit en nombre total (effectif), soit en équivalents temps plein (ETP).",
          "L'ETP se calcule en divisant le nombre d'heures travaillées par le nombre d'heures d'un poste à temps plein.",
          "Cette donnée est essentielle pour déterminer la taille de l'entreprise au sens de la directive comptable 2013/34/UE."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-vi",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "vi"
        ],
        "ref": "§24 (e vi.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-10"
        ],
        "form_fields": [
          "b1p27-e-vi_countries"
        ],
        "schema_steps": [
          "b1p27-e-vi"
        ]
      },
      "display": {
        "title": "Pays des opérations principales et emplacement des actifs importants",
        "description": [
          "Conformément au paragraphe 27, point e) vi) de la norme VS, l'entreprise doit indiquer :",
          "• Le pays où sont exercées ses activités principales (par exemple : siège, site de production majeur) ;",
          "• Le ou les pays où se trouvent ses actifs importants (usines, entrepôts, infrastructures critiques, etc.).",
          "Cette information permet d'évaluer les risques et les impacts en lien avec le contexte géographique (ex. : exposition climatique, réglementation locale, chaînes d'approvisionnement)."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-vii",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "vii"
        ],
        "ref": "§24 (e vii.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B1-11"
        ],
        "form_fields": [
          "b1p27-e-vii_sites_locations"
        ],
        "schema_steps": [
          "b1p27-e-vii"
        ]
      },
      "display": {
        "title": "Sites détenus, loués ou gérés",
        "description": [
          "Conformément au paragraphe 27, point e) vii) et aux paragraphes 73 à 76 de la norme VS, l'entreprise doit fournir la liste des sites qu'elle détient, loue ou gère, en précisant pour chacun :",
          "• Le nom du site ;",
          "• L'adresse complète (code postal, ville, pays) ;",
          "• Les coordonnées géographiques (latitude et longitude, à cinq décimales).",
          "Ces données facilitent l'analyse des risques physiques et environnementaux liés à l'emplacement (climat, eau, biodiversité, etc.)."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p28",
      "norm": {
        "module": "B1",
        "paragraph": 25,
        "points": [],
        "ref": "§25",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B1-12"
        ],
        "form_fields": [
          "b1p28_labels"
        ],
        "schema_steps": [
          "b1p28"
        ]
      },
      "display": {
        "title": "Labels ou certifications liés à la durabilité obtenus",
        "description": [
          "Conformément au paragraphe 28 de la norme VS, lorsqu'une certification ou un label a été obtenu, il convient de fournir une brève description, incluant :",
          "• Le nom de l'émetteur du label ou de la certification ;",
          "• La date d'obtention ;",
          "• La note ou le score, si applicable.",
          "Il peut s'agir, par exemple, d'un label écologique européen, national ou international lié aux produits, à la gestion environnementale ou à la responsabilité sociale."
        ],
        "anchors": []
      }
    },
    {
      "id": "b2p29",
      "norm": {
        "module": "B2",
        "paragraph": 26,
        "points": [],
        "ref": "§26-27",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B2-01-02-03"
        ],
        "form_fields": [],
        "schema_steps": [
          "b2p29"
        ]
      },
      "display": {
        "title": "Pratiques, politiques ou initiatives spécifiques sur des sujets de durabilité",
        "description": [
          "Conformément aux paragraphes 29 et 27 de la norme VS, l'entreprise doit indiquer, pour chaque sujet de durabilité (climat, pollution, eau, biodiversité, économie circulaire, effectifs, chaîne de valeur, communautés affectées, consommateurs, conduite des affaires) :",
          "• S'il existe des pratiques, politiques ou initiatives spécifiques sur ce point (b2p29-a).",
          "• Si elles sont accessibles publiquement (b2p29-b).",
          "• Des objectifs chiffrés ou mesurables ont été fixés pour en suivre la mise en œuvre (b2p29-d).",
          "Ces informations permettent d'évaluer l'engagement réel de l'entreprise dans une transition vers une économie durable. Un état structuré est recommandé pour organiser ces réponses par enjeu."
        ],
        "anchors": []
      }
    },
    {
      "id": "b2p29-a",
      "norm": {
        "module": "B2",
        "paragraph": 26,
        "points": [],
        "ref": "§26-27",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B2-01"
        ],
        "form_fields": [
          "b2p29_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Pratiques, politiques ou initiatives spécifiques sur des sujets de durabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b2p29-b",
      "norm": {
        "module": "B2",
        "paragraph": 26,
        "points": [],
        "ref": "§26-27",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B2-02"
        ],
        "form_fields": [
          "b2p29_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Pratiques, politiques ou initiatives spécifiques sur des sujets de durabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b2p29-d",
      "norm": {
        "module": "B2",
        "paragraph": 26,
        "points": [],
        "ref": "§26-27",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B2-03"
        ],
        "form_fields": [
          "b2p29_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Pratiques, politiques ou initiatives spécifiques sur des sujets de durabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b2p29-complete",
      "norm": {
        "module": "B2",
        "paragraph": 26,
        "points": [],
        "ref": "§26-27",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "b2p29_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Pratiques, politiques ou initiatives spécifiques sur des sujets de durabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b2p29__c2p47",
      "norm": {
        "module": "B2",
        "paragraph": 26,
        "points": [],
        "ref": "§26-27 / C2 §48-49",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B2-01-02-03_C2-01-02-03"
        ],
        "form_fields": [],
        "schema_steps": [
          "b2p29__c2p47"
        ]
      },
      "display": {
        "title": "Pratiques, politiques ou initiatives spécifiques sur des sujets de durabilité",
        "description": [
          "Conformément au paragraphe 29 de la norme VS, l'entreprise doit indiquer, pour chaque sujet de durabilité (climat, pollution, eau, biodiversité, économie circulaire, effectifs, chaîne de valeur, communautés affectées, consommateurs, conduite des affaires) :",
          "• S'il existe des pratiques, politiques ou initiatives spécifiques sur ce point (b2p29-a).",
          "• Si elles sont accessibles publiquement (b2p29-b).",
          "• Des objectifs chiffrés ou mesurables ont été fixés pour en suivre la mise en œuvre (b2p29-d).",
          "Ces informations permettent d'évaluer l'engagement réel de l'entreprise dans une transition vers une économie durable. Un état structuré est recommandé pour organiser ces réponses par enjeu."
        ],
        "anchors": [
          "b2p29",
          "b2p30",
          "c2p47",
          "c2p48"
        ]
      }
    },
    {
      "id": "b3p32",
      "norm": {
        "module": "B3",
        "paragraph": 29,
        "points": [],
        "ref": "§29",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B3-01"
        ],
        "form_fields": [
          "b3p32__b3p33_energy_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Consommation d'énergie",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b3p32__b3p33",
      "norm": {
        "module": "B3",
        "paragraph": 29,
        "points": [],
        "ref": "§29, §30, §31, §50-53",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B3-01-02-03"
        ],
        "form_fields": [],
        "schema_steps": [
          "b3p32__b3p33"
        ]
      },
      "display": {
        "title": "Énergie et émissions GES",
        "description": [
          "Conformément aux paragraphes 32, 30 et 50 à 53 de la norme VS :",
          "• Paragraphe 32 : l'entreprise publie sa consommation totale d'énergie en MWh, ventilée par source (électricité, combustibles, renouvelable / non renouvelable).",
          "• Paragraphe 33 : l'entreprise doit déclarer ses émissions brutes de GES (en tonnes équivalent CO₂ – tCO₂e) selon le GHG Protocol (version 2004), ventilées comme suit :",
          "  - Scope 1 : émissions directes (combustion, véhicules, etc.) ;",
          "  - Scope 2 : émissions indirectes liées à l'énergie achetée (électricité, chaleur, vapeur) – méthode basée sur les localisations ;",
          "  - Total scopes 1 + 2.",
          "• Paragraphes 49 à 52 : il est recommandé de publier également les émissions de GES du scope 3, soit les émissions indirectes de la chaîne de valeur, ventilées selon les 15 catégories du GHG Protocol (amont : achats, transport ; aval : usage, fin de vie, etc.).",
          "Cette publication est facultative mais constitue une pratique recommandée pour certains secteurs à fort impact.",
          "Les données doivent être calculées avec précision, transparence et cohérence. La norme autorise l'utilisation d'unités alternatives utilisées dans la norme ISO 14064-1, si plus adapté."
        ],
        "anchors": [
          "b3p32",
          "vsme-p-30",
          "b3p33",
          "vsme-p-50",
          "vsme-p-51",
          "vsme-p-52",
          "vsme-p-53"
        ]
      }
    },
    {
      "id": "b3p30",
      "norm": {
        "module": "B3",
        "paragraph": 30,
        "points": [],
        "ref": "§30, 50-53",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B3-02"
        ],
        "form_fields": [
          "b3p32__b3p33_emissions_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Émissions brutes de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b3p49__b3p52",
      "norm": {
        "module": "B3",
        "paragraph": 50,
        "points": [],
        "ref": "§50-53",
        "necessity": "sector_consideration",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B3-03"
        ],
        "form_fields": [
          "b3p32__b3p33_emissions_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Émissions brutes de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b4p34",
      "norm": {
        "module": "B4",
        "paragraph": 32,
        "points": [],
        "ref": "§32",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B4-01-02",
          "B4-01"
        ],
        "form_fields": [],
        "schema_steps": [
          "b4p34"
        ]
      },
      "display": {
        "title": "Polluants rejetés",
        "description": [
          "Conformément au paragraphe 34 de la norme VS, ces données doivent être fournies uniquement si :",
          "• L'entreprise est déjà soumise à une obligation légale ou réglementaire de déclaration environnementale, ou",
          "• Elle fournit volontairement ces informations, par exemple dans le cadre d'un système de management environnemental.",
          "",
          "Les exigences sont les suivantes :",
          "• B4-01 : indiquer la quantité de chaque polluant rejeté dans l'environnement (en masse).",
          "• B4-02 : préciser pour chaque polluant le milieu concerné : air, eau ou sol.",
          "",
          "Les polluants à déclarer peuvent inclure des substances comme les oxydes d'azote, les composés organiques volatils, les métaux lourds, etc. (voir précisions dans la norme, §116-117)."
        ],
        "anchors": []
      }
    },
    {
      "id": "b4p34-microplastics",
      "norm": {
        "module": "B4",
        "paragraph": 32,
        "points": [],
        "ref": "§32",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B4-02"
        ],
        "form_fields": [
          "b4p34_pollutants"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Polluants rejetés",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b4p34-public-links",
      "norm": {
        "module": "B4",
        "paragraph": 32,
        "points": [],
        "ref": "§32",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B4-03"
        ],
        "form_fields": [
          "b4p34-public-links_links"
        ],
        "schema_steps": [
          "b4p34-public-links"
        ]
      },
      "display": {
        "title": "Polluants rejetés",
        "description": [
          "Conformément au paragraphe 34 de la norme VS, si les informations sur les rejets de polluants dans l'air, l'eau ou le sol sont déjà accessibles au public, l'entreprise peut fournir un lien URL vers le document ou la base de données concernée (site institutionnel, registre environnemental, etc.).",
          "",
          "Ce renvoi évite la duplication d'information et permet une consultation directe par les parties prenantes. L'hyperlien doit pointer vers une source disponible au moment de la déclaration."
        ],
        "anchors": []
      }
    },
    {
      "id": "b5p35",
      "norm": {
        "module": "B5",
        "paragraph": 33,
        "points": [],
        "ref": "§33",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B5-01-02-03-04"
        ],
        "form_fields": [],
        "schema_steps": [
          "b5p35"
        ]
      },
      "display": {
        "title": "Zones sensibles sur le plan de la biodiversité",
        "description": [
          "Conformément au paragraphe 35 de la norme VS, l'entreprise doit déclarer les informations suivantes si au moins un site est situé dans ou près d'une zone sensible pour la biodiversité :",
          "• B5-01 : Nombre de sites concernés (détenus, loués ou gérés).",
          "• B5-02 : Superficie totale (en hectares) de ces sites.",
          "• B5-03 : Nom(s) des zones sensibles concernées (ex. : zones Natura 2000, aires protégées, zones Ramsar).",
          "• B5-04 : Précision sur la localisation de chaque site : dans la zone ou à proximité immédiate.",
          "Ces informations permettent d'évaluer les impacts potentiels de l'activité sur la biodiversité et les écosystèmes sensibles."
        ],
        "anchors": []
      }
    },
    {
      "id": "b5p35-site-areas",
      "norm": {
        "module": "B5",
        "paragraph": 33,
        "points": [],
        "ref": "§33",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B5-02"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Zones sensibles sur le plan de la biodiversité",
        "description": [],
        "anchors": [],
        "workfile_title": "Sites en zones sensibles - superficie des sites"
      }
    },
    {
      "id": "b5p35-sensitive-zone-names",
      "norm": {
        "module": "B5",
        "paragraph": 33,
        "points": [],
        "ref": "§33",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B5-03"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Zones sensibles sur le plan de la biodiversité",
        "description": [],
        "anchors": [],
        "workfile_title": "Sites en zones sensibles - zones concernées"
      }
    },
    {
      "id": "b5p35-site-characteristics",
      "norm": {
        "module": "B5",
        "paragraph": 33,
        "points": [],
        "ref": "§33",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B5-04"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Zones sensibles sur le plan de la biodiversité",
        "description": [],
        "anchors": [],
        "workfile_title": "Sites en zones sensibles - dans la zone ou à proximité"
      }
    },
    {
      "id": "b5p35-has-sensitive-sites",
      "norm": {
        "module": "B5",
        "paragraph": 33,
        "points": [],
        "ref": "§33",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B5-01"
        ],
        "form_fields": [
          "b5p35_has_sensitive_sites"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Zones sensibles sur le plan de la biodiversité",
        "description": [],
        "anchors": [],
        "workfile_title": "Sites en zones sensibles - nombre de sites"
      }
    },
    {
      "id": "b6p36",
      "norm": {
        "module": "B6",
        "paragraph": 35,
        "points": [],
        "ref": "§35",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B6-01",
          "b6p36-water-stressed-withdrawal"
        ],
        "form_fields": [
          "b6p36__b6p37_water_usage"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Prélèvement et consommation d'eau sur les sites",
        "description": [],
        "anchors": [
          "b6p36"
        ],
        "workfile_title": "Prélèvements d'eau - tous les sites"
      }
    },
    {
      "id": "b6p36__b6p37",
      "norm": {
        "module": "B6",
        "paragraph": 35,
        "points": [],
        "ref": "§35-36",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B6-01-02-03-04"
        ],
        "form_fields": [],
        "schema_steps": [
          "b6p36__b6p37"
        ]
      },
      "display": {
        "title": "Prélèvement et consommation d'eau sur les sites",
        "description": [
          "Conformément aux paragraphes 36 et 37 de la norme VS, l'entreprise doit fournir des informations sur sa gestion de l'eau, notamment :",
          "• B6-01 : Prélèvement total d'eau (en m³), toutes sources confondues.",
          "• B6-03 : Consommation d'eau (en m³), calculée comme la différence entre les prélèvements et les rejets, uniquement si les procédés de production consomment beaucoup d'eau (ex. : séchage, refroidissement, irrigation).",
          "• B6-04 : Consommation d'eau des sites situés dans des zones de stress hydrique, pour ces mêmes entreprises.",
          "Ces données permettent d'évaluer la pression exercée sur les ressources en eau, notamment dans les régions où cette ressource est limitée ou fragile."
        ],
        "anchors": [
          "b6p36",
          "b6p37"
        ]
      }
    },
    {
      "id": "b6p37",
      "norm": {
        "module": "B6",
        "paragraph": 36,
        "points": [],
        "ref": "§36",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B6-03"
        ],
        "form_fields": [
          "b6p36__b6p37_water_usage"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Prélèvement et consommation d'eau sur les sites",
        "description": [],
        "anchors": [
          "b6p37"
        ],
        "workfile_title": "Consommation d'eau - tous les sites"
      }
    },
    {
      "id": "b6p37-water-stressed-consumption",
      "norm": {
        "module": "B6",
        "paragraph": 36,
        "points": [],
        "ref": "§36",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B6-04"
        ],
        "form_fields": [
          "b6p36__b6p37_water_usage"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Prélèvement et consommation d'eau sur les sites",
        "description": [],
        "anchors": [
          "b6p37"
        ],
        "workfile_title": "Consommation d'eau - sites en stress hydrique"
      }
    },
    {
      "id": "b7p38",
      "norm": {
        "module": "B7",
        "paragraph": 37,
        "points": [],
        "ref": "§37",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B7-01-02"
        ],
        "form_fields": [
          "b7p38_applies_circular_economy"
        ],
        "schema_steps": [
          "b7p38"
        ]
      },
      "display": {
        "title": "Application des principes de l'économie circulaire",
        "description": [
          "Conformément au paragraphe 38 de la norme VS :",
          "• B7-01 : l'entreprise indique si elle applique les principes de l'économie circulaire (Oui/Non). Cela inclut la réduction de l'utilisation de ressources, la réutilisation, la réparation, le recyclage, ou la conception de produits circulaires.",
          "• B7-02 : si une réponse positive est donnée, l'entreprise doit décrire de manière narrative les actions mises en œuvre, par exemple :",
          "  – Boucles de réutilisation internes",
          "  – Processus de réduction des déchets en production",
          "  – Intégration de matériaux recyclés",
          "  – Modèle économique basé sur la fonctionnalité ou la location.",
          "Ces informations mettent en valeur l'engagement de l'entreprise à réduire son empreinte matière et à optimiser ses flux de ressources."
        ],
        "anchors": []
      }
    },
    {
      "id": "b7p38-circular-economy-details",
      "norm": {
        "module": "B7",
        "paragraph": 37,
        "points": [],
        "ref": "§37",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B7-02"
        ],
        "form_fields": [
          "b7p38_circular_economy_details"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Économie circulaire",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b7p39",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B7-03-04-05"
        ],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": [
          "b7p39"
        ]
      },
      "display": {
        "title": "Production et traitement des déchets",
        "description": [
          "Conformément au paragraphe 39 de la norme VS, l'entreprise doit fournir les informations suivantes :",
          "• B7-03 : Quantité totale annuelle de déchets dangereux, exprimée en masse et ventilée par type si possible.",
          "• B7-04 : Quantité totale annuelle de déchets non dangereux, exprimée en masse.",
          "• B7-05 : Volume total de déchets orientés vers le recyclage ou la réutilisation, toutes catégories confondues.",
          "Ces données permettent d'évaluer l'efficacité de la gestion des déchets et l'engagement de l'entreprise dans la réduction à la source et la valorisation des matières."
        ],
        "anchors": []
      }
    },
    {
      "id": "b7p39-hazardous-waste-produced",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B7-03"
        ],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Production annuelle totale de déchets",
        "description": [],
        "anchors": [],
        "workfile_title": "Quantité totale annuelle de déchets dangereux (masse), ventilée par type si possible"
      }
    },
    {
      "id": "b7p39-non-hazardous-waste-produced",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B7-04"
        ],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Production annuelle totale de déchets",
        "description": [],
        "anchors": [],
        "workfile_title": "Quantité totale annuelle de déchets non dangereux (masse)"
      }
    },
    {
      "id": "b7p39-recycled-reused-total",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B7-05"
        ],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Production annuelle totale de déchets",
        "description": [],
        "anchors": [],
        "workfile_title": "Volume total de déchets orientés vers le recyclage ou la réutilisation, toutes catégories confondues"
      }
    },
    {
      "id": "b7p39-recycled-reused-hazardous",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Production annuelle totale de déchets",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b7p39-recycled-reused-non-hazardous",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Production annuelle totale de déchets",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b7p39-recycled-reused-proportion",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "b7p39_waste_production"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Proportion de déchets recyclés ou réutilisés",
        "description": [],
        "anchors": [],
        "workfile_title": "Part des déchets orientés vers le recyclage ou la réutilisation, exprimée en pourcentage (VSME 2026)"
      }
    },
    {
      "id": "b7p39-c",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [
          "c"
        ],
        "ref": "§38 (c)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B7-06"
        ],
        "form_fields": [
          "b7p39-c_material_flows_details"
        ],
        "schema_steps": [
          "b7p39-c"
        ]
      },
      "display": {
        "title": "Flux massique annuel des matières concernées utilisées",
        "description": [
          "Conformément au paragraphe 39, point c) de la norme VS, l'entreprise doit indiquer les flux massiques annuels de matières (en tonnes) si elle exerce ses activités dans un secteur à forte utilisation de matériaux, tels que :",
          "• la fabrication ;",
          "• la construction ;",
          "• l'emballage ;",
          "• ou tout autre secteur à flux significatifs.",
          "La déclaration doit inclure les principales catégories de matières premières utilisées (ex. : acier, bois, plastique, béton) afin d'évaluer l'impact matière et les possibilités d'optimisation circulaire."
        ],
        "anchors": [],
        "workfile_title": "Flux massiques annuels des matières premières utilisées (secteurs à flux significatifs)"
      }
    },
    {
      "id": "b7p39-c-has-significant-flow-sector",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [
          "c"
        ],
        "ref": "§38 (c)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "b7p39-c_is_significant_flow_sector"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Flux massique annuel des matières concernées utilisées",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b8p40",
      "norm": {
        "module": "B8",
        "paragraph": 39,
        "points": [],
        "ref": "§39",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B8-01-02-03"
        ],
        "form_fields": [],
        "schema_steps": [
          "b8p40"
        ]
      },
      "display": {
        "title": "Employés et leurs caractéristiques générales",
        "description": [
          "Conformément au paragraphe 40 de la norme VS, l'entreprise doit fournir les informations suivantes sur ses effectifs, en nombre total ou équivalent temps plein :",
          "• B8-01 : Répartition par type de contrat : temporaire / à durée indéterminée",
          "• B8-02 : Répartition par genre : homme / femme / autre / non précisé",
          "• B8-03 : Répartition par pays, si l'entreprise opère dans plusieurs pays",
          "Ces données permettent une vision de la structure de l'emploi, essentielle pour analyser les pratiques sociales, la diversité et la localisation des ressources humaines."
        ],
        "anchors": [
          "b8p40",
          "vsme-p-39-a",
          "vsme-p-39-b",
          "vsme-p-39-c"
        ]
      }
    },
    {
      "id": "b8p40-a",
      "norm": {
        "module": "B8",
        "paragraph": 39,
        "points": [
          "a"
        ],
        "ref": "§39 (a)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B8-01"
        ],
        "form_fields": [
          "b8p40_employee_distribution",
          "b8p40__c5p59_employee_distribution"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Répartition des employés par type de contrat",
        "description": [],
        "anchors": [
          "vsme-p-39-a"
        ]
      }
    },
    {
      "id": "b8p40-b",
      "norm": {
        "module": "B8",
        "paragraph": 39,
        "points": [
          "b"
        ],
        "ref": "§39 (b)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B8-02"
        ],
        "form_fields": [
          "b8p40_employee_distribution",
          "b8p40__c5p59_employee_distribution"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Répartition des employés par genre",
        "description": [],
        "anchors": [
          "vsme-p-39-b"
        ]
      }
    },
    {
      "id": "b8p40-c",
      "norm": {
        "module": "B8",
        "paragraph": 39,
        "points": [
          "c"
        ],
        "ref": "§39 (c)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B8-03"
        ],
        "form_fields": [
          "b8p40_employee_distribution",
          "b8p40__c5p59_employee_distribution"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Répartition des employés par pays",
        "description": [],
        "anchors": [
          "vsme-p-39-c"
        ]
      }
    },
    {
      "id": "b8p40__c5p59",
      "norm": {
        "module": "B8",
        "paragraph": 39,
        "points": [],
        "ref": "§39, §59-60",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B8-01-02-03_C5-01-02-03"
        ],
        "form_fields": [],
        "schema_steps": [
          "b8p40__c5p59"
        ]
      },
      "display": {
        "title": "Employés et leurs caractéristiques générales",
        "description": [
          "Conformément au paragraphe 40 de la norme VS, l'entreprise doit fournir les informations suivantes sur ses effectifs, en nombre total ou équivalent temps plein :",
          "• B8-01 : Répartition par type de contrat : temporaire / à durée indéterminée",
          "• B8-02 : Répartition par genre : homme / femme / autre / non précisé",
          "• B8-03 : Répartition par pays, si l'entreprise opère dans plusieurs pays",
          "Conformément aux paragraphes 59 et 60 de la norme VS, l'entreprise peut indiquer, à titre volontaire, la répartition homme/femme au niveau de la direction ainsi que le nombre de travailleurs indépendants et temporaires.",
          "Ces données permettent une vision de la structure de l'emploi, essentielle pour analyser les pratiques sociales, la diversité et la localisation des ressources humaines."
        ],
        "anchors": []
      }
    },
    {
      "id": "c5p58",
      "norm": {
        "module": "C5",
        "paragraph": 58,
        "points": [],
        "ref": "§58",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B8-04"
        ],
        "form_fields": [
          "c5p58_turnover_data"
        ],
        "schema_steps": [
          "c5p58"
        ]
      },
      "display": {
        "title": "Taux de rotation des salariés",
        "description": [
          "Le taux de rotation (ou turnover) correspond au pourcentage de salariés ayant quitté l'entreprise pendant l'exercice, calculé par rapport à l'effectif total.",
          "Cette donnée permet d'évaluer la stabilité de l'emploi, l'attractivité de l'organisation et les risques liés à la gestion des talents.",
          "Retrouver toute la norme ici : sitedocumentation.fr"
        ],
        "anchors": []
      }
    },
    {
      "id": "b9p41",
      "norm": {
        "module": "B9",
        "paragraph": 41,
        "points": [],
        "ref": "§41",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B9-01-02-03"
        ],
        "form_fields": [
          "b9p41_work_accidents"
        ],
        "schema_steps": [
          "b9p41"
        ]
      },
      "display": {
        "title": "Accidents et maladies au travail",
        "description": [
          "Conformément au paragraphe 41 de la norme VS, l'entreprise doit fournir les données suivantes concernant la sécurité au travail :",
          "• B9-01 : Nombre total d'accidents du travail enregistrables (arrêt de travail, hospitalisation, blessure grave).",
          "• B9-02 : Taux d'accidents du travail, exprimé en pourcentage ou en fréquence, selon la formule : (nombre d'accidents enregistrables / nombre total d'heures travaillées) × 200 000.",
          "• B9-03 : Nombre de décès liés au travail, incluant les décès dus à un accident professionnel et ceux dus à une maladie professionnelle reconnue.",
          "Ces indicateurs permettent d'évaluer le niveau de risque, la performance en matière de prévention et les responsabilités de l'entreprise en santé-sécurité."
        ],
        "anchors": []
      }
    },
    {
      "id": "b9p41-work-accident-rate",
      "norm": {
        "module": "B9",
        "paragraph": 41,
        "points": [],
        "ref": "§41",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B9-02"
        ],
        "form_fields": [
          "b9p41_work_accidents"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Accidents et maladies au travail",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b9p41-work-related-fatalities",
      "norm": {
        "module": "B9",
        "paragraph": 41,
        "points": [],
        "ref": "§41",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B9-03"
        ],
        "form_fields": [
          "b9p41_work_accidents"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Accidents et maladies au travail",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b10p42-a",
      "norm": {
        "module": "B10",
        "paragraph": 42,
        "points": [
          "a"
        ],
        "ref": "§42 (a)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B10-01"
        ],
        "form_fields": [],
        "schema_steps": [
          "b10p42-a"
        ]
      },
      "display": {
        "title": "Rémunération minimum",
        "description": [
          "Conformément au paragraphe 42, point a) de la norme VS, l'entreprise doit indiquer si l'ensemble de ses employés reçoivent une rémunération au moins égale :",
          "• au salaire minimum légal dans le pays où ils sont employés, ou",
          "• au minimum défini par une convention collective applicable, s'il est plus favorable.",
          "Cette donnée est obligatoire, quel que soit l'effectif, et constitue un indicateur fondamental de conformité sociale et de respect des droits économiques des travailleurs."
        ],
        "anchors": [
          "b10p42-a"
        ]
      }
    },
    {
      "id": "b10p42-b",
      "norm": {
        "module": "B10",
        "paragraph": 42,
        "points": [
          "b"
        ],
        "ref": "§42 (b)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B10-02"
        ],
        "form_fields": [
          "b10p42-b_gender_pay_gap"
        ],
        "schema_steps": [
          "b10p42-b"
        ]
      },
      "display": {
        "title": "Écart de rémunération",
        "description": [
          "Conformément au paragraphe 42, point b) de la norme VS (version 2026), la publication de l'écart de rémunération n'est requise que si l'entreprise entre dans le champ d'application de la directive (UE) 2023/970 sur la transparence des rémunérations.",
          "L'entreprise doit indiquer l'écart moyen de rémunération entre les femmes et les hommes, exprimé en pourcentage du salaire moyen masculin.",
          "Les salaires moyens doivent être indiqués en brut (avant déduction des cotisations sociales et impôts).",
          "Cet indicateur permet d'évaluer l'équité salariale et de détecter d'éventuelles inégalités structurelles dans la politique de rémunération."
        ],
        "anchors": [
          "b10p42-b"
        ]
      }
    },
    {
      "id": "b10p42-c",
      "norm": {
        "module": "B10",
        "paragraph": 42,
        "points": [
          "c"
        ],
        "ref": "§42 (c)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B10-03"
        ],
        "form_fields": [
          "b10p42-c_collective_agreements"
        ],
        "schema_steps": [
          "b10p42-c"
        ]
      },
      "display": {
        "title": "Couverture par une convention collective",
        "description": [
          "Conformément au paragraphe 42, point c) de la norme VS, ce champ est requis uniquement si l'entreprise emploie 50 personnes ou plus.",
          "L'entreprise doit indiquer la part de ses effectifs (en %) couverte par une convention collective, qu'elle soit :",
          "- Sectorielle, territoriale ou d'entreprise",
          "- Exigée ou volontaire",
          "Cette information reflète le degré de structuration du dialogue social et l'encadrement collectif des droits et devoirs entre employeur et salariés."
        ],
        "anchors": [
          "b10p42-c"
        ]
      }
    },
    {
      "id": "b10p42-d",
      "norm": {
        "module": "B10",
        "paragraph": 42,
        "points": [
          "d"
        ],
        "ref": "§42 (d)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "B10-04"
        ],
        "form_fields": [],
        "schema_steps": [
          "b10p42-d"
        ]
      },
      "display": {
        "title": "Formation des salariés",
        "description": [
          "L'entreprise doit indiquer le nombre moyen d'heures de formation par salarié au cours de l'exercice. Depuis la version 2026 de la norme VS, cette donnée n'est plus ventilée par genre.",
          "Sont prises en compte toutes les formations professionnelles, quelle qu'en soit la durée, le format (présentiel, en ligne) ou la thématique (technique, sécurité, management, etc.).",
          "Cet indicateur mesure l'investissement dans le développement des compétences et l'adaptation des effectifs aux évolutions du métier."
        ],
        "anchors": [
          "b10p42-d"
        ]
      }
    },
    {
      "id": "b11p43",
      "norm": {
        "module": "B11",
        "paragraph": 43,
        "points": [],
        "ref": "§43",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B11-01-02"
        ],
        "form_fields": [
          "b11p43_corruption_fines"
        ],
        "schema_steps": [
          "b11p43"
        ]
      },
      "display": {
        "title": "Condamnations et amendes",
        "description": [
          "Conformément au paragraphe 43 de la norme VS, l'entreprise doit déclarer :",
          "• B11-01 : L'existence de sanctions, amendes ou pénalités imposées par une autorité publique pour non-respect d'obligations légales ou réglementaires au cours de l'exercice (ex. : droit du travail, environnement, fiscalité, sécurité).",
          "• B11-02 : Tout cas avéré de corruption ou de conflit d'intérêts impliquant l'entreprise, ses dirigeants ou employés pendant la période considérée.",
          "Ces indicateurs reflètent le niveau de conformité réglementaire et l'éthique de gouvernance de l'entreprise."
        ],
        "anchors": []
      }
    },
    {
      "id": "b11p43-corruption-bribery-fines",
      "norm": {
        "module": "B11",
        "paragraph": 43,
        "points": [],
        "ref": "§43",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B11-02"
        ],
        "form_fields": [
          "b11p43_corruption_fines"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Condamnations et amendes",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b11p43-has-issues",
      "norm": {
        "module": "B11",
        "paragraph": 43,
        "points": [],
        "ref": "§43",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "b11p43_has_corruption_issues"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Condamnations et amendes",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c1p46-a",
      "norm": {
        "module": "C1",
        "paragraph": 47,
        "points": [
          "a"
        ],
        "ref": "§47 (a)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C1-01"
        ],
        "form_fields": [
          "c1p46-a_products_services"
        ],
        "schema_steps": [
          "c1p46-a"
        ]
      },
      "display": {
        "title": "Description des produits et services",
        "description": [
          "Conformément au paragraphe 46 de la norme VS, vous devez fournir une description des grands groupes de produits ou services offerts par votre entreprise.",
          "Cette information est obligatoire et permet aux partenaires commerciaux de mieux comprendre la nature de vos activités économiques."
        ],
        "anchors": []
      }
    },
    {
      "id": "c1p46-b",
      "norm": {
        "module": "C1",
        "paragraph": 47,
        "points": [
          "b"
        ],
        "ref": "§47 (b)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C1-02"
        ],
        "form_fields": [
          "c1p46-b_markets"
        ],
        "schema_steps": [
          "c1p46-b"
        ]
      },
      "display": {
        "title": "Description des marchés sur lesquels l'entreprise opère",
        "description": [
          "Selon le paragraphe 46 de la norme VS, vous devez décrire les marchés significatifs où votre entreprise opère (par exemple B2B, commerce de gros, commerce de détail) ainsi que les pays concernés.",
          "Cette information permet d'évaluer la portée géographique et commerciale de vos activités."
        ],
        "anchors": []
      }
    },
    {
      "id": "c1p46-c",
      "norm": {
        "module": "C1",
        "paragraph": 47,
        "points": [
          "c"
        ],
        "ref": "§47 (c)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C1-03"
        ],
        "form_fields": [
          "c1p46-c_key_relationships"
        ],
        "schema_steps": [
          "c1p46-c"
        ]
      },
      "display": {
        "title": "Fournisseurs et leurs secteurs d'activités",
        "description": [
          "Conformément au paragraphe 46 de la norme VS, vous devez fournir une description des relations commerciales clés, y compris les fournisseurs, clients, canaux de distribution et types de consommateurs.",
          "Ces informations permettent de mieux comprendre l'ancrage économique et la dépendance éventuelle de l'entreprise vis-à-vis de certaines parties prenantes."
        ],
        "anchors": []
      }
    },
    {
      "id": "c1p46-c-suppliers",
      "norm": {
        "module": "C1",
        "paragraph": 47,
        "points": [
          "c"
        ],
        "ref": "§47 (c)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C1-04"
        ],
        "form_fields": [
          "c1p46-c-suppliers_suppliers_sectors"
        ],
        "schema_steps": [
          "c1p46-c-suppliers"
        ]
      },
      "display": {
        "title": "Fournisseurs et leurs secteurs d'activités",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c1p46-d",
      "norm": {
        "module": "C1",
        "paragraph": 47,
        "points": [
          "d"
        ],
        "ref": "§47 (d)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C1-05"
        ],
        "form_fields": [
          "c1p46-d_strategy_elements"
        ],
        "schema_steps": [
          "c1p46-d"
        ]
      },
      "display": {
        "title": "Éléments clés de la stratégie de l'entreprise, qui se rapportent aux questions de durabilité ou qui les affectent",
        "description": [
          "Vous devez fournir une description des principaux éléments stratégiques de votre entreprise en lien avec les enjeux de durabilité.",
          "Ces informations permettent d'évaluer dans quelle mesure votre stratégie prend en compte les risques et opportunités liés aux aspects environnementaux, sociaux et de gouvernance."
        ],
        "anchors": []
      }
    },
    {
      "id": "c2p47",
      "norm": {
        "module": "C2",
        "paragraph": 48,
        "points": [],
        "ref": "§48-49",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C2-01"
        ],
        "form_fields": [
          "b2p29__c2p47_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Description des pratiques de durabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c2p47-b",
      "norm": {
        "module": "C2",
        "paragraph": 48,
        "points": [],
        "ref": "§48-49",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C2-02"
        ],
        "form_fields": [
          "b2p29__c2p47_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Description des objectifs de durabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c2p48",
      "norm": {
        "module": "C2",
        "paragraph": 48,
        "points": [],
        "ref": "§48-49",
        "necessity": "voluntary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C2-03"
        ],
        "form_fields": [
          "b2p29__c2p47_sustainability_table"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Niveau de responsabilité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-01-02-03-04-05-06"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": [
          "c3p53"
        ]
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [
          "Indiquer si l'entreprise s'est fixé des objectifs de réduction des émissions de GES pour les scopes 1, 2, et le cas échéant 3.",
          "Préciser pour chaque objectif :",
          "• l'année cible et sa valeur,",
          "• l'année de référence et sa valeur,",
          "• les unités utilisées,",
          "• la part des émissions concernée par ces cibles.",
          "Ces éléments doivent être ventilés par scope conformément au paragraphe 53 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c3p53-target-years",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-01"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53-target-values",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-02"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53-base-years",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-03"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53-base-year-values",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-04"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53-target-units",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-05"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53-scope-coverage",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [],
        "ref": "§54",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-06"
        ],
        "form_fields": [
          "c3p53_ghg_targets"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Objectifs de réduction des émissions de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p53-e",
      "norm": {
        "module": "C3",
        "paragraph": 54,
        "points": [
          "e"
        ],
        "ref": "§54 (e)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-07"
        ],
        "form_fields": [
          "c3p53-e_main_actions"
        ],
        "schema_steps": [
          "c3p53-e"
        ]
      },
      "display": {
        "title": "Actions pour atteindre les objectifs de réduction des émissions",
        "description": [
          "Décrire les principales actions mises en œuvre par l'entreprise pour atteindre les objectifs de réduction des émissions de gaz à effet de serre fixés pour les scopes 1, 2 et éventuellement 3.",
          "Ces informations doivent être cohérentes avec les objectifs déclarés précédemment.",
          "Conformément au paragraphe 53 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c3p54",
      "norm": {
        "module": "C3",
        "paragraph": 55,
        "points": [],
        "ref": "§55",
        "necessity": "voluntary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-08"
        ],
        "form_fields": [
          "c3p54__c3p55_main_actions"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Plan de transition climatique",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c3p54__c3p55",
      "norm": {
        "module": "C3",
        "paragraph": 55,
        "points": [],
        "ref": "§55–56",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-08-09"
        ],
        "form_fields": [],
        "schema_steps": [
          "c3p54__c3p55"
        ]
      },
      "display": {
        "title": "Plan de transition climatique",
        "description": [
          "Indiquer si l'entreprise a adopté un plan de transition pour l'atténuation du changement climatique.",
          "Si oui, décrire ce plan et expliquer en quoi il contribue à la réduction des émissions de GES.",
          "Si aucun plan n'a encore été adopté, indiquer si un tel plan est prévu et à quelle échéance.",
          "Ces informations concernent en priorité les entreprises opérant dans des secteurs à fort impact climatique (paragraphes 54 et 56 de la norme VS)."
        ],
        "anchors": []
      }
    },
    {
      "id": "c3p55",
      "norm": {
        "module": "C3",
        "paragraph": 56,
        "points": [],
        "ref": "§56",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C3-09"
        ],
        "form_fields": [
          "c3p54__c3p55_future_plan"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Plan de transition climatique",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c4p56-a",
      "norm": {
        "module": "C4",
        "paragraph": 57,
        "points": [
          "a"
        ],
        "ref": "§57 (a)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C4-01"
        ],
        "form_fields": [
          "c4p56-a_climate_risks"
        ],
        "schema_steps": [
          "c4p56-a"
        ]
      },
      "display": {
        "title": "Aléas et événements liés au changement climatique",
        "description": [
          "Décrire les aléas climatiques (ex. : inondations, sécheresses, vagues de chaleur) et les événements liés à la transition climatique (ex. : évolution réglementaire, fiscalité carbone, pression du marché) identifiés par l'entreprise comme des risques bruts pour ses activités, ses actifs ou sa chaîne de valeur.",
          "Conformément au paragraphe 56 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c4p56-b",
      "norm": {
        "module": "C4",
        "paragraph": 57,
        "points": [
          "b"
        ],
        "ref": "§57 (b)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C4-02"
        ],
        "form_fields": [
          "c4p56-b_time_horizons_actions"
        ],
        "schema_steps": [
          "c4p56-b"
        ]
      },
      "display": {
        "title": "Exposition aux aléas et événements liés au changement climatique",
        "description": [
          "Expliquer comment l'entreprise a évalué l'exposition et la sensibilité de ses actifs, activités et chaîne de valeur face aux aléas climatiques et événements de transition identifiés.",
          "Cette évaluation peut porter sur la localisation des sites, les infrastructures critiques, les fournisseurs ou les marchés concernés.",
          "Conformément au paragraphe 56 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c4p56-c",
      "norm": {
        "module": "C4",
        "paragraph": 57,
        "points": [
          "c"
        ],
        "ref": "§57 (c)",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C4-03"
        ],
        "form_fields": [
          "c4p56-c_climate_risk_horizons"
        ],
        "schema_steps": [
          "c4p56-c"
        ]
      },
      "display": {
        "title": "Horizons temporels des aléas et événements liés au changement climatique",
        "description": [
          "Préciser les horizons temporels retenus pour l'analyse des risques climatiques et des événements de transition identifiés (court, moyen ou long terme).",
          "Cette information permet d'évaluer à quel moment les risques sont susceptibles d'impacter les activités ou la performance de l'entreprise.",
          "Conformément au paragraphe 56 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c4p56-d",
      "norm": {
        "module": "C4",
        "paragraph": 57,
        "points": [
          "d"
        ],
        "ref": "§57 (d)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C4-04"
        ],
        "form_fields": [],
        "schema_steps": [
          "c4p56-d"
        ]
      },
      "display": {
        "title": "Actions d'adaptation au changement climatique",
        "description": [
          "Indiquer si l'entreprise a pris des mesures d'adaptation pour répondre aux aléas climatiques et événements de transition identifiés comme des risques.",
          "Ces mesures peuvent concerner, par exemple, la résilience des infrastructures, la diversification de la chaîne d'approvisionnement ou des ajustements opérationnels.",
          "Conformément au paragraphe 56 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c4p56-d-has-adaptation-measures",
      "norm": {
        "module": "C4",
        "paragraph": 57,
        "points": [
          "d"
        ],
        "ref": "§57 (d)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [
          "c4p56-d_adaptation_measures"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Actions d'adaptation au changement climatique",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c4p57",
      "norm": {
        "module": "C4",
        "paragraph": 58,
        "points": [],
        "ref": "§58",
        "necessity": "voluntary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C4-05"
        ],
        "form_fields": [
          "c4p57_financial_impacts"
        ],
        "schema_steps": [
          "c4p57"
        ]
      },
      "display": {
        "title": "Évaluation des risques potentiels dûs au changement climatique",
        "description": [
          "Décrire les effets négatifs potentiels que les risques climatiques pourraient avoir sur la performance financière ou les opérations de l'entreprise à court, moyen ou long terme.",
          "Indiquer si ces risques sont évalués comme élevés, moyens ou faibles.",
          "Conformément au paragraphe 57 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c5p59__c5p60",
      "norm": {
        "module": "C5",
        "paragraph": 59,
        "points": [],
        "ref": "§59",
        "necessity": "voluntary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C5-01"
        ],
        "form_fields": [
          "c5p59_management_ratio"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Ratio femmes/hommes au niveau de la direction",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c5p60",
      "norm": {
        "module": "C5",
        "paragraph": 60,
        "points": [],
        "ref": "§60",
        "necessity": "voluntary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C5-02"
        ],
        "form_fields": [
          "c5p60_workforce_extras"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Travailleurs indépendants sans personnel travaillant exclusivement pour l'entreprise",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c5p60-temporary-agency-workers",
      "norm": {
        "module": "C5",
        "paragraph": 60,
        "points": [],
        "ref": "§60",
        "necessity": "voluntary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C5-03"
        ],
        "form_fields": [
          "c5p60_workforce_extras"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Travailleurs temporaires mis à disposition par des entreprises de travail",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C6-01-02-03-04-05-06-07-08-09"
        ],
        "form_fields": [
          "c6p61_policy_exists"
        ],
        "schema_steps": [
          "c6p61"
        ]
      },
      "display": {
        "title": "Politiques et procédures en matière de droits de l'homme",
        "description": [
          "Indiquer si l'entreprise dispose d'un code de conduite ou d'une politique des droits de l'homme applicable à son propre personnel.",
          "Si oui, préciser si cette politique couvre notamment : travail des enfants, travail forcé, traite des êtres humains, discrimination, prévention des accidents, et autres sujets (à préciser).",
          "Indiquer également si un mécanisme de traitement des plaintes ou dispositif d'alerte interne est en place.",
          "Ces éléments sont exigés par le paragraphe 61 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-covered-topics",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.i",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-02"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Politique couvre le travail des enfants",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-forced-labour",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.ii",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-03"
        ],
        "form_fields": [
          "c6p61_policy_forced_labour"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Politique couvre le travail forcé",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-trafficking",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.iii",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-04"
        ],
        "form_fields": [
          "c6p61_policy_trafficking"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Politique couvre la traite des êtres humains",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-discrimination",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.iv",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-05"
        ],
        "form_fields": [
          "c6p61_policy_discrimination"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Politique couvre la discrimination",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-accident-prevention",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.v",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-06"
        ],
        "form_fields": [
          "c6p61_policy_accidents"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Politique couvre la prévention des accidents",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-other-topics-flag",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.vi",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-07"
        ],
        "form_fields": [
          "c6p61_policy_other"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Politique couvre d'autres sujets",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-policy-other-topics-list",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.b.vi",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C6-08"
        ],
        "form_fields": [
          "c6p61_policy_other_text"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Liste des autres sujets couverts",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6p61-grievance-mechanism",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61.c",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C6-09"
        ],
        "form_fields": [
          "c6p61_grievance_mechanism"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Mécanisme de traitement des plaintes",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-01-02-03-04-05-06-07-08-09"
        ],
        "form_fields": [
          "c7p62_incident_child_labour_self"
        ],
        "schema_steps": [
          "c7p62"
        ]
      },
      "display": {
        "title": "Incidents en matière de droits de l'homme",
        "description": [
          "Indiquer si l'entreprise a constaté des incidents confirmés au sein de son propre personnel portant sur : travail des enfants, travail forcé, traite des êtres humains, discrimination, ou autres sujets (à préciser).",
          "Décrire les mesures prises pour remédier à ces incidents lorsque des incidents sont signalés.",
          "Indiquer également si l'entreprise a connaissance d'incidents confirmés concernant des travailleurs de la chaîne de valeur, des communautés affectées, des consommateurs ou des utilisateurs finaux, et fournir les précisions nécessaires.",
          "Ces informations sont exigées au titre du paragraphe 62 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "c7p62-forced-labour-self",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-02"
        ],
        "form_fields": [
          "c7p62_incident_forced_labour_self"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "a) ii. travail forcé",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-trafficking-self",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-03"
        ],
        "form_fields": [
          "c7p62_incident_trafficking_self"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "a) iii. traite des êtres humains",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-discrimination-self",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-04"
        ],
        "form_fields": [
          "c7p62_incident_discrimination_self"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "a) iv. discrimination",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-other-self",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-05"
        ],
        "form_fields": [
          "c7p62_incident_other_self"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "a) v. autres",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-other-subjects-list",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-06"
        ],
        "form_fields": [
          "c7p62_other_subjects_list"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "Préciser les autres sujets de constats des incidents confirmés",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-remediation-measures",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-07"
        ],
        "form_fields": [
          "c7p62_measures_description"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "b) Mesures mises en œuvre pour remédier aux cas",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-value-chain-incidents",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-08"
        ],
        "form_fields": [
          "c7p62_incidents_in_value_chain"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "c) Incidents avérés impliquant la chaîne de valeur",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7p62-value-chain-details",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [
          "C7-09"
        ],
        "form_fields": [
          "c7p62_value_chain_details"
        ],
        "schema_steps": []
      },
      "display": {
        "title": "c) Précisions sur les incidents de la chaîne de valeur",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c8p63",
      "norm": {
        "module": "C8",
        "paragraph": 63,
        "points": [],
        "ref": "§63",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C8-01"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": null,
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c8p63-tobacco-revenue",
      "norm": {
        "module": "C8",
        "paragraph": 63,
        "points": [],
        "ref": "§63",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C8-02"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": null,
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c8p63-fossil-fuels-revenue",
      "norm": {
        "module": "C8",
        "paragraph": 63,
        "points": [],
        "ref": "§63",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C8-03"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": null,
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c8p63-chemicals-revenue",
      "norm": {
        "module": "C8",
        "paragraph": 63,
        "points": [],
        "ref": "§63",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C8-04"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": null,
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c8p63__c8p64",
      "norm": {
        "module": "C8",
        "paragraph": 63,
        "points": [],
        "ref": "§63",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C8-01-02-03-04-05"
        ],
        "form_fields": [],
        "schema_steps": [
          "c8p63__c8p64"
        ]
      },
      "display": {
        "title": "Revenus dans certains secteurs",
        "description": [
          "Indiquer les revenus générés dans les secteurs sensibles suivants, si l'entreprise y est active (conformément au paragraphe 63 de la norme VS) :",
          "• armes prohibées (mines antipersonnel, armes à sous-munitions, armes chimiques et biologiques)",
          "• culture et production de tabac",
          "• combustibles fossiles (charbon, pétrole et gaz), avec la ventilation des revenus par charbon, pétrole et gaz",
          "• production de produits chimiques (division 20.2 de l'annexe I du règlement (CE) n° 1893/2006).",
          "Fournir les montants concernés si applicable."
        ],
        "anchors": [
          "c8p63"
        ]
      }
    },
    {
      "id": "c9p64",
      "norm": {
        "module": "C9",
        "paragraph": 65,
        "points": [],
        "ref": "§65",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "C9-01"
        ],
        "form_fields": [],
        "schema_steps": [
          "c9p64"
        ]
      },
      "display": {
        "title": "Répartition hommes / femmes au sein de l'organe de gouvernance",
        "description": [
          "Fournir le ratio entre femmes et hommes siégeant dans l'organe de gouvernance de l'entreprise (par exemple : conseil d'administration ou organe équivalent).",
          "Ce champ est requis pour évaluer la représentation équilibrée des genres dans les instances dirigeantes.",
          "Conformément au paragraphe 59 de la norme VS."
        ],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e-iii__b1p27-e-iv",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e",
          "iii",
          "–iv"
        ],
        "ref": "§24 (e iii.–iv.)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Bilan et chiffre d'affaires",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b1p27-e",
      "norm": {
        "module": "B1",
        "paragraph": 24,
        "points": [
          "e"
        ],
        "ref": "§24 (e)",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Informations générales sur notre entreprise",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b3-energy-consumption",
      "norm": {
        "module": "B3",
        "paragraph": 29,
        "points": [],
        "ref": "§29",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Consommation d'énergie",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b3-ghg-emissions",
      "norm": {
        "module": "B3",
        "paragraph": 30,
        "points": [],
        "ref": "§30, 50-53",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Émissions brutes de GES",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b4-polluants",
      "norm": {
        "module": "B4",
        "paragraph": 32,
        "points": [],
        "ref": "§32",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Polluants rejetés",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b5-zones-sensibles",
      "norm": {
        "module": "B5",
        "paragraph": 33,
        "points": [],
        "ref": "§33",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Zones sensibles sur le plan de la biodiversité",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b7-circular-economy",
      "norm": {
        "module": "B7",
        "paragraph": 37,
        "points": [],
        "ref": "§37",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Économie circulaire",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b7-material-flows",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [
          "c"
        ],
        "ref": "§38 (c)",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Flux massique annuel des matières concernées utilisées",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b7-waste-production",
      "norm": {
        "module": "B7",
        "paragraph": 38,
        "points": [],
        "ref": "§38",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Production et traitement des déchets",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b8-employee-characteristics",
      "norm": {
        "module": "B8",
        "paragraph": 39,
        "points": [],
        "ref": "§39",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Employés et leurs caractéristiques générales",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b8-employee-turnover",
      "norm": {
        "module": "C5",
        "paragraph": 58,
        "points": [],
        "ref": "§58",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Taux de rotation des salariés",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b9-workplace-accidents",
      "norm": {
        "module": "B9",
        "paragraph": 41,
        "points": [],
        "ref": "§41",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": true,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Accidents et maladies au travail",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b11-convictions",
      "norm": {
        "module": "B11",
        "paragraph": 43,
        "points": [],
        "ref": "§43",
        "necessity": "necessary_if_applicable",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Condamnations et amendes",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c6-human-rights",
      "norm": {
        "module": "C6",
        "paragraph": 61,
        "points": [],
        "ref": "§61",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Politiques et procédures en matière de droits de l'homme",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c7-human-rights-incidents",
      "norm": {
        "module": "C7",
        "paragraph": 62,
        "points": [],
        "ref": "§62",
        "necessity": "necessary",
        "voluntary_under_light_tier": true,
        "value_chain_cap": {
          "le10": false,
          "gt10": true
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Incidents en matière de droits de l'homme",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "c8-sensitive-sectors",
      "norm": {
        "module": "C8",
        "paragraph": 63,
        "points": [],
        "ref": "§63",
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": "Revenus dans certains secteurs",
        "description": [],
        "anchors": []
      }
    },
    {
      "id": "b1-02",
      "norm": {
        "module": "B1",
        "paragraph": null,
        "points": [],
        "ref": null,
        "necessity": "necessary",
        "voluntary_under_light_tier": false,
        "value_chain_cap": {
          "le10": false,
          "gt10": false
        }
      },
      "aliases": {
        "legacy": [
          "B1-02"
        ],
        "form_fields": [],
        "schema_steps": []
      },
      "display": {
        "title": null,
        "description": [],
        "anchors": []
      }
    }
  ]
}
